import { ToggleButtonGroup } from "@mui/material";
import styled from "@emotion/styled";

export const ChartToggleButtonGroup = styled(ToggleButtonGroup)`
  & .MuiToggleButton-root {
    min-width: 112px;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 100%;
  }
`;
